import React, { useState, useEffect } from "react";
import FlashCoachLogo from "../../components/_Icons/FlashCoachLogo";
import IntroIcon from "./icons/intro.svg";
import TextField from "@material-ui/core/TextField";
import Button from "./../../components/Button";
import { useHistory } from "react-router-dom";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import styles from "./HelpRequestForm.module.scss";
import ReCAPTCHA from "react-google-recaptcha";
import ClassNames from "classnames";
import { useFormik } from "formik";
import * as yup from "yup";

export const HelpRequestWelcome = () => {
  const history = useHistory();

  const [initialValues, setInitialValues] = useState({});
  const [employeeId, setEmployeeId] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [verified, setVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const grecaptchaObject = window.grecaptcha;
  const { addNotification } = useNotification();

  useEffect(() => {
    setInitialValues({
      employeeId: employeeId ?? "",
      captcha: captcha ?? "",
    });
  }, [employeeId, captcha]);

  const validationSchema = yup.object({
    employeeId: yup.string().required("Enter your employee id"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: values => {
      getEmployeeInfoByEmpId();
    },
    enableReinitialize: true,
  });

  const getEmployeeInfoByEmpId = async () => {
    try {
      setIsLoading(true);
      console.log("employeeId", employeeId);

      const response = await apiRequest.post(`/api/employeeInfoById`, {
        employeeId: employeeId,
        captcha: captcha,
      });
      if (response.status === 200) {
        const employeeInfo = response.data.data;
        if (employeeInfo.token && employeeInfo.token !== "") {
          sessionStorage.setItem(
            "HRF_EMP_INFO",
            JSON.stringify({
              TOKEN: employeeInfo.token,
              UID: employeeInfo.uid,
              EMPLOYEE_ID: employeeId,
              EMPLOYEE_EMAIL_ID: employeeInfo.employee_email_id,
              EMPLOYEE_NAME: employeeInfo.employee_name,
              CAMPAIGN_ID: employeeInfo.campaign_id,
              FUNCTIONAL_UNIT: employeeInfo.functional_unit,
              COUNTRY_NAME: employeeInfo.country_name,
              CC_EMAIL: employeeInfo.cc_email,
            })
          );
          const key = employeeInfo.token.split(".")[0];
          history.push(`/help-request/${key}/form`);
        }
      } else {
        addNotification("Employee details not found!", "error");
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.topNavbar}>
        <div className={styles.navbarContainer}>
          <div style={{ width: "13%" }}>
            <FlashCoachLogo />
          </div>
        </div>
      </div>

      <div className={styles.contentSection}>
        <img src={IntroIcon} alt={"introIcon"} style={{ height: "35%" }} />
        <div
          className={ClassNames(styles.flexSection, styles.width50Percent)}
          style={{ width: "50%" }}
        >
          <h1 className={styles.titleText}>{"Need help? Tell us here."}</h1>
          <p className={ClassNames(styles.introText)}>
            {
              "Simply fill out this quick form with your question or concern and our team will get you back on track. Please note that each form is limited to one issue only."
            }
          </p>
        </div>
        <div className={styles.formSection}>
          <div className={ClassNames(styles.formGroup, styles.flexCenter)}>
            <text className={styles.empIdText}>
              {"What's your employee ID? "}
            </text>
            <TextField
              style={{ width: "30%" }}
              size="small"
              variant="outlined"
              placeholder="12345"
              value={employeeId}
              name="employeeId"
              InputProps={{
                sx: {
                  "& .MuiOutlinedInput-input": {
                    padding: "4px 8px", // Adjust the padding values as needed
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                },
              }}
              onChange={e => {
                setEmployeeId(e.target.value);
                formik.handleChange(e);
              }}
              error={
                formik.touched.employeeId && Boolean(formik.errors.employeeId)
              }
              helperText={formik.touched.employeeId && formik.errors.employeeId}
            />
          </div>
          <div className={ClassNames(styles.formGroup, styles.flexCenter)}>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              grecaptcha={grecaptchaObject}
              onChange={value => {
                console.log("Captcha value", value);
                setCaptcha(value);
                setVerified(true);
                formik.setFieldValue(value);
              }}
            />
          </div>
          <div className={styles.formGroup}>
            <Button
              className={ClassNames(styles.formSubmitButton)}
              type="submit"
              onClick={() => {
                formik.handleSubmit();
              }}
              disabled={!verified}
            >
              {"Let's get started!"}
            </Button>
          </div>
          <div className={ClassNames(styles.cancelButton, styles.formGroup)}>
            <Button type="button" onClick={() => history.replace("/")}>
              {"Cancel"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
